import {
  MdButton,
  TdlFullscreendialog
} from "@torre-labs/material";
import Vue from "vue";

import AppMixin from "@/mixins/AppMixin";

export default Vue.extend({
  components: {
    MdButton,
    TdlFullscreendialog
  },
  mixins: [AppMixin],
  methods: {
    cancel(): void {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params
      });
    }
  }
});
